import { render } from "./ColumnArticle.vue?vue&type=template&id=2276153c"
import script from "./ColumnArticle.vue?vue&type=script&lang=js"
export * from "./ColumnArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__